var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolutionLine6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_20480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3438 37.1951C50.7634 16.5825 79.9146 16.5825 87.3343 37.1951V37.1951H43.3438V37.1951Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1405 88.8351V89.3351H21.6405V88.8351H21.1405ZM12.3379 88.8351V88.3351H11.8379V88.8351H12.3379ZM12.3379 99.7108H11.8379V100.211H12.3379V99.7108ZM118.339 99.7108V100.211H118.839V99.7108H118.339ZM118.339 88.8351H118.839V88.3351H118.339V88.8351ZM109.536 88.8351H109.036V89.3351H109.536V88.8351ZM21.6405 45.6164C21.6405 41.2417 25.1869 37.6953 29.5616 37.6953V36.6953C24.6346 36.6953 20.6405 40.6894 20.6405 45.6164H21.6405ZM21.6405 88.8351V45.6164H20.6405V88.8351H21.6405ZM12.3379 89.3351H21.1405V88.3351H12.3379V89.3351ZM12.8379 99.7108V88.8351H11.8379V99.7108H12.8379ZM118.339 99.2108H12.3379V100.211H118.339V99.2108ZM117.839 88.8351V99.7108H118.839V88.8351H117.839ZM109.536 89.3351H118.339V88.3351H109.536V89.3351ZM109.036 45.6164V88.8351H110.036V45.6164H109.036ZM101.115 37.6953C105.49 37.6953 109.036 41.2417 109.036 45.6164H110.036C110.036 40.6894 106.042 36.6953 101.115 36.6953V37.6953ZM29.5616 37.6953H101.115V36.6953H29.5616V37.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.623,
    y: 45.8047,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.0566,
    y: 45.8047,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4922,
    y: 45.8047,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2871 72.5929C37.2871 67.9421 41.0573 64.1719 45.7082 64.1719H48.7722C53.4231 64.1719 57.1933 67.9421 57.1933 72.5929V88.5271H37.2871V72.5929Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0825 88.8351V89.3351H78.5825V88.8351H78.0825ZM69.5957 88.8351V88.3351H69.0957V88.8351H69.5957ZM69.5957 99.7108H69.0957V100.211H69.5957V99.7108ZM118.334 99.7108V100.211H118.834V99.7108H118.334ZM118.334 88.8351H118.834V88.3351H118.334V88.8351ZM109.53 88.8351H109.03V89.3351H109.53V88.8351ZM78.5825 45.6164C78.5825 41.2417 82.1289 37.6953 86.5036 37.6953V36.6953C81.5766 36.6953 77.5825 40.6894 77.5825 45.6164H78.5825ZM78.5825 88.8351V45.6164H77.5825V88.8351H78.5825ZM69.5957 89.3351H78.0825V88.3351H69.5957V89.3351ZM70.0957 99.7108V88.8351H69.0957V99.7108H70.0957ZM118.334 99.2108H69.5957V100.211H118.334V99.2108ZM117.834 88.8351V99.7108H118.834V88.8351H117.834ZM109.53 89.3351H118.334V88.3351H109.53V89.3351ZM109.03 45.6164V88.8351H110.03V45.6164H109.03ZM101.109 37.6953C105.484 37.6953 109.03 41.2417 109.03 45.6164H110.03C110.03 40.6894 106.036 36.6953 101.109 36.6953V37.6953ZM86.5036 37.6953H101.109V36.6953H86.5036V37.6953Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_20480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(-0.00195312 0.171875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolutionLine6);
export default __webpack_public_path__ + "static/media/naverSolutionLine6.7fd139a53051eb7f4259d2cd24e07346.svg";
export { ForwardRef as ReactComponent };